import React from 'react'
import _ from 'lodash'
import { Accordion, Table } from 'camino-react'

const ReportAccordion = ({ data }) => {
  const accordionTableColumns = [
    { text: 'ID', accessor: 'id' },
    { text: 'Status', accessor: 'status_text' },
    { text: 'Client', accessor: 'client_name' },
    { text: 'Title', accessor: 'title' },
    { text: 'Contact', accessor: 'contact_name', maxWidth: '300' },
    {
      text: 'Date', accessor: 'created_at', type: 'datetime'
    },
    {
      text: 'Response SLA', accessor: 'sla', type: 'badge'
    },
    { text: 'Ticket type', accessor: 'ticket_type_name' }
  ]

  const accordionDetails = _.map(data, (value, title) => ({
    title,
    subTitle: (
      <>
        <strong>
          {value.length}
        </strong>
        {' '}
      tickets
      </>
    ),
    content: (
      <Table
        columns={accordionTableColumns}
        data={value}
      />
    )
  }))

  return (
    <div>
      <Accordion>
        {accordionDetails}
      </Accordion>
    </div>
  )
}

export default ReportAccordion
